import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import GestionOm from "./GestionOm";
import AccionMejora from "../CargaOm/AccionMejora";

function GestionOmLider() {
  let { idSolicitud } = useParams();

  const [list, setList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Modal detalle
  const [showDetalle, setShowDetalle] = useState(false);
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);

  const abrirDetalle = (row) => {
    setDetalleSeleccionado(row);
    setShowDetalle(true);
  };

  const cerrarDetalle = () => {
    setShowDetalle(false);
    setDetalleSeleccionado(null);
  };

  useEffect(() => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejora/${idSolicitud}/aa`,
      )
      .then((response) => {
        setList(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => console.error(error));
  }, [idSolicitud]);

  // Filtro
  const filteredList = list.filter((item) =>
    Object.values(item).some(
      (val) =>
        val && val.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);
  // Paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < Math.ceil(filteredList.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const [showDescripcion, setShowDescripcion] = useState(false);
  const [descripcionSeleccionada, setDescripcionSeleccionada] = useState("");
  const abrirDescripcion = (descripcion) => {
    setDescripcionSeleccionada(descripcion);
    setShowDescripcion(true);
  };

  const cerrarDescripcion = () => {
    setShowDescripcion(false);
    setDescripcionSeleccionada("");
  };
  const cortarTexto = (texto, limite = 120) => {
    if (!texto) return "";
    return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
  };
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header">
          <h6 className="m-0 font-weight-bold text-primary">
            Información Oportunidades de Mejora
          </h6>
        </div>

        <div className="card-body">
          <input
            type="text"
            placeholder="Buscar..."
            className="form-control mb-3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Descripción</th>
                  <th>OM Similar</th>
                  <th>Estado</th>
                  <th>Origen</th>
                  <th>Tipo Visita</th>
                  <th>Fecha</th>
                  <th>Calificación</th>
                  <th>Detalle</th>
                  <th>Acción</th>
                  <th>Gestión</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.map((row, index) => (
                  <tr key={index}>
                    <td>{row.id}</td>
                    <td style={{ maxWidth: "350px" }}>
                      <div
                        style={{
                          whiteSpace: "normal",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {cortarTexto(row.descripcion, 100)}
                      </div>

                      {row.descripcion?.length > 100 && (
                        <button
                          className="btn btn-link p-0 mt-1"
                          style={{ fontSize: "13px" }}
                          onClick={() => abrirDescripcion(row.descripcion)}
                        >
                          Ver más
                        </button>
                      )}
                    </td>

                    <td>{row.descripcionOmSimilar}</td>
                    <td>{row.estadoOportunidad}</td>
                    <td>{row.origen}</td>
                    <td>{row.tipoVisita}</td>
                    <td>{new Date(row.fechaVisita).toLocaleDateString()}</td>
                    <td
                      style={{
                        backgroundColor:
                          row.calificacion < 15 ? "#FFF3CD" : "#D4EDDA",
                        color: "#000",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {row.calificacion}
                    </td>

                    <td className="text-center">
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => abrirDetalle(row)}
                      >
                        Ver detalle
                      </button>
                    </td>

                    <td>
                      <GestionOm idOm={row.id} idSolicitud={idSolicitud} />
                    </td>
                    <td>
                      <AccionMejora idOm={row.id} idSolicitud={idSolicitud} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Paginador */}
          <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
            {/* Botón anterior */}
            <button
              className="btn btn-primary mb-2"
              onClick={prevPage}
              disabled={currentPage === 1}
            >
              Anterior
            </button>

            {/* Información y selector de página */}
            <div className="d-flex align-items-center mb-2">
              <span className="mr-2" style={{ fontSize: "14px" }}>
                Página <strong>{currentPage}</strong> de{" "}
                <strong>{totalPages || 1}</strong>
              </span>

              <select
                className="form-control"
                style={{ width: "80px" }}
                value={currentPage}
                onChange={(e) => goToPage(Number(e.target.value))}
              >
                {Array.from({ length: totalPages || 1 }, (_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
            </div>

            {/* Botón siguiente */}
            <button
              className="btn btn-primary mb-2"
              onClick={nextPage}
              disabled={currentPage >= totalPages || totalPages === 0}
            >
              Siguiente
            </button>
          </div>

          {/* Información de registros */}
          <div
            className="text-center mt-2"
            style={{
              fontSize: "12px",
              color: "#6c757d",
            }}
          >
            Mostrando <strong>{currentItems.length}</strong> de{" "}
            <strong>{filteredList.length}</strong> registros
          </div>
        </div>
      </div>

      {/* MODAL DETALLE */}
      {showDetalle && detalleSeleccionado && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              {/* HEADER */}
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  Detalle Oportunidad de Mejora – #{detalleSeleccionado.id}
                </h5>
                <button
                  className="btn-close btn-close-white"
                  onClick={cerrarDetalle}
                ></button>
              </div>

              {/* BODY */}
              <div className="modal-body">
                {/* TIPO OM */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">
                    Tipo de OM luego de la Agrupación
                  </h6>
                  <div className="row">
                    <div className="col-md-4">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Estructura: {detalleSeleccionado.estructura}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Proceso: {detalleSeleccionado.proceso}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Resultado: {detalleSeleccionado.resultado}
                      </span>
                    </div>
                  </div>
                </div>

                {/* RIESGOS */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">
                    Riesgo que genera la NO intervención de la OM (Registre 1,
                    según criterio)
                  </h6>
                  <div className="row">
                    <div className="col-md-4">
                      <span className="badge border border-dark text-primary w-100 p-2">
                        Asistencial: {detalleSeleccionado.asistencial}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="badge border border-dark text-primary w-100 p-2">
                        Reputacional: {detalleSeleccionado.reputacional || 0}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="badge border border-dark text-primary w-100 p-2">
                        Clinico: {detalleSeleccionado.clinica}
                      </span>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <span className="badge border border-dark text-primary w-100 p-2">
                        Poblacional: {detalleSeleccionado.poblacional}
                      </span>
                    </div>
                    <div className="col-md-6  ">
                      <span className="badge border border-dark text-primary w-100 p-2">
                        Administrativo:{" "}
                        {detalleSeleccionado.administrativo || 0}
                      </span>
                    </div>
                  </div>
                </div>

                {/* IMPACTO */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">
                    IMPACTO (Registre 1 según el grupo al que impacte)
                  </h6>
                  <div className="row">
                    <div className="col-md-3">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Para Usuarios: {detalleSeleccionado.paraUsuarios}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Para Trabajadores:{" "}
                        {detalleSeleccionado.paraTrabajadores}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Legal: {detalleSeleccionado.legal}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="badge border border-primary text-primary w-100 p-2">
                        Financiera: {detalleSeleccionado.financiera}
                      </span>
                    </div>
                  </div>
                </div>

                {/* EVALUACIÓN */}
                <div className="mb-3">
                  <h6 className="text-success mb-3">Evaluación</h6>
                  <div className="row text-center">
                    <div className="col-md-4">
                      <div className="card shadow-sm">
                        <div className="card-body">
                          <h6>Probabilidad</h6>
                          <strong>{detalleSeleccionado.probabilidad}</strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card shadow-sm">
                        <div className="card-body">
                          <h6>Sumatoria</h6>
                          <strong>{detalleSeleccionado.sumatoria}</strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div
                        className="card shadow-sm"
                        style={{
                          backgroundColor:
                            detalleSeleccionado.calificacion < 12
                              ? "#f1e885ff"
                              : "#9dec86ff",
                        }}
                      >
                        <div className="card-body">
                          <h6>Calificación</h6>
                          <strong>{detalleSeleccionado.calificacion}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* FOOTER */}
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={cerrarDetalle}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDescripcion && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              {/* HEADER */}
              <div className="modal-header bg-info text-white">
                <h5 className="modal-title">Descripción completa</h5>
                <button
                  className="btn-close btn-close-white"
                  onClick={cerrarDescripcion}
                ></button>
              </div>

              {/* BODY */}
              <div className="modal-body">
                <p style={{ whiteSpace: "pre-line" }}>
                  {descripcionSeleccionada}
                </p>
              </div>

              {/* FOOTER */}
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={cerrarDescripcion}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GestionOmLider;
